import { render, staticRenderFns } from "./PackageConfigSub.vue?vue&type=template&id=b7d3b670&scoped=true"
import script from "./PackageConfigSub.vue?vue&type=script&lang=js"
export * from "./PackageConfigSub.vue?vue&type=script&lang=js"
import style0 from "./PackageConfigSub.vue?vue&type=style&index=0&id=b7d3b670&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d3b670",
  null
  
)

export default component.exports